module.exports = __webpack_public_path__ + "media/images/countryrect/sd-d02cc84fa729197c1fa21384b887cac5.svg";